import { ModuleManager, SectionList } from "@module-system";
import startEventCollecting from "./callEventCollector.js";

/**
 * @type {import('@module-system').IModule}
 */
var module = {
  name: "CoreModules",
  version: "1.0.0",
  async register() {
    startEventCollecting();

    const audioButtonConfig = window.CONFIG?.CALL_BUTTONS?.AUDIO_MUTE;
    if (
      !audioButtonConfig ||
      typeof audioButtonConfig.ENABLED === "undefined" ||
      typeof audioButtonConfig.ORDER === "undefined"
    ) {
      throw new Error(
        "AUDIO_MUTE:{enabled:bool,order:number} should be defined in config.js in CALL_BUTTONS"
      );
    }

    const videoButtonConfig = window.CONFIG?.CALL_BUTTONS?.VIDEO_MUTE;
    if (
      !videoButtonConfig ||
      typeof videoButtonConfig.ENABLED === "undefined" ||
      typeof videoButtonConfig.ORDER === "undefined"
    ) {
      throw new Error(
        "VIDEO_MUTE:{enabled:bool,order:number} should be defined in config.js in CALL_BUTTONS"
      );
    }

    const hangupButtonConfig = window.CONFIG?.CALL_BUTTONS?.HANGUP;
    if (
      !hangupButtonConfig ||
      typeof hangupButtonConfig.ENABLED === "undefined" ||
      typeof hangupButtonConfig.ORDER === "undefined"
    ) {
      throw new Error(
        "HANGUP:{enabled:bool,order:number} should be defined in config.js in CALL_BUTTONS"
      );
    }

    ModuleManager.addViewModule({
      ViewComponent: (
        await import("../components/VideoCall/AudioMuteButton.vue")
      ).default,
      order: audioButtonConfig.ORDER,
      Condition: () => audioButtonConfig.ENABLED,
      key: "audio-mute-button",
      section: SectionList.CallButtonsList,
      stackable: false,
    });

    ModuleManager.addViewModule({
      ViewComponent: (
        await import("../components/VideoCall/VideoMuteButton.vue")
      ).default,
      order: videoButtonConfig.ORDER,
      Condition: () => videoButtonConfig.ENABLED,
      key: "video-mute-button",
      section: SectionList.CallButtonsList,
      stackable: false,
    });

    ModuleManager.addViewModule({
      ViewComponent: (await import("../components/VideoCall/HangupButton.vue")).default,
      order: hangupButtonConfig.ORDER,
      Condition: () => hangupButtonConfig.ENABLED,
      key: "hangup-button",
      section: SectionList.CallButtonsList,
      stackable: false,
    });
  },
};
export default module;
